import { api } from "@/redux/api";

import {
	SavedFilter,
	SavedFilterDeleteResponse,
	SavedFilterDeleteResponseSchema,
	SavedFilterResponse,
	SavedFilterResponseSchema,
	SavedFilterSchema,
} from "./savedFilter.schema";

export const savedFilterApi = api.injectEndpoints({
	endpoints: (builder) => ({
		getSavedFilters: builder.query<SavedFilterResponse, void>({
			query: () => ({
				url: "saved-filters",
				responseSchema: SavedFilterResponseSchema,
			}),
			providesTags: ["SavedFilter"],
		}),
		createSavedFilter: builder.mutation<
			SavedFilter,
			{ name: string; filterConfig: Record<string, unknown> }
		>({
			query: (body) => ({
				url: "saved-filters",
				method: "POST",
				body,
				responseSchema: SavedFilterSchema,
			}),
			invalidatesTags: ["SavedFilter"],
		}),
		deleteSavedFilter: builder.mutation<SavedFilterDeleteResponse, number>({
			query: (id) => ({
				url: `saved-filters/${id}`,
				method: "DELETE",
				responseSchema: SavedFilterDeleteResponseSchema,
			}),
			invalidatesTags: ["SavedFilter"],
		}),
	}),
});

export const {
	useGetSavedFiltersQuery,
	useCreateSavedFilterMutation,
	useDeleteSavedFilterMutation,
} = savedFilterApi;
